export default __webpack_public_path__ + "static/media/privacy-policy.f83367e1.pdf";